import { useRouter } from 'next/router'

import TopicNewest from './TopicNewest'
import { useSETrackerEvent } from 'app/PelatihanMandiriPage/hooks/useSETrackEvent'
import { useLocalStorage } from 'utils/hooks/useLocalStorage'

import type { TTopicNewest } from 'types/microlearning'

interface TopicNewestProps {
  items: TTopicNewest[]
  isLoading: boolean
}

const URL_TOPIC = '/pelatihan-mandiri/daftar-topik'

const TopicNewestList = ({ items, isLoading }: TopicNewestProps) => {
  const useFilter = useLocalStorage('topic-sort-filter', 'recommendation')
  const { SETrackPromotionTopic } = useSETrackerEvent()
  const router = useRouter()

  const handleClickButton = () => {
    SETrackPromotionTopic({
      action_type: 'click_promotion_topic',
      action_value: 'view_all',
    })
    useFilter[1]('newest')
    router.push(URL_TOPIC)
  }

  if (isLoading) {
    return <TopicNewest isLoading={true} />
  }

  if (items && items.length) {
    return (
      <>
        <div className="grid grid-cols-1 gap-4">
          {(items || []).map((item, idx) => (
            <TopicNewest key={idx} {...item} />
          ))}
        </div>
        <div
          className="rounded-md border border-gray-50 text-center p-2 font-semibold"
          onClick={() => handleClickButton()}
        >
          Lihat topik lain
        </div>
      </>
    )
  }

  return null
}

export default TopicNewestList
